import { Character, GetUserCharactersGQL, UpdateCharacterGQL, CreateCharacterGQL } from 'generated/graphql';
import { State, Action, StateContext, Selector, select } from '@ngxs/store';
import { makeDefaultEntitiesState, makeBaseEntitiesState } from '@modules/app-common/state/entities.state';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { LoggedInUserState } from '@modules/auth/store';
import { MutationResult } from 'apollo-angular';

export { Character } from 'generated/graphql';

export class CharactersFindByUserAction {
  static readonly type = '[Characters] Find All My Characters';

  constructor() {}
}

export class CharactersSaveAction {
  static readonly type = '[Characters] Save';

  constructor(
    public payload: {
      character: Partial<Character>;
    }
  ) {}
}

const CharactersBaseEntitiesState = makeBaseEntitiesState<Character>('characters');

@State({
  name: 'characters',
  defaults: makeDefaultEntitiesState(),
})
@Injectable()
export class CharactersEntitiesState extends CharactersBaseEntitiesState {
  private createCharacterGQL = inject(CreateCharacterGQL);
  private updateCharacterGQL = inject(UpdateCharacterGQL);
  private getUserCharactersGQL = inject(GetUserCharactersGQL);

  @Selector()
  static myCharacters(state: { entityMap: Record<string, Character> }): (userId: string) => Character[] {
    return (userId: string) => {
      return Object.values(state.entityMap).filter((entity) => entity.userId === userId);
    };
  }

  @Action(CharactersFindByUserAction)
  findUserCharacters(ctx: StateContext<any>) {
    return this.getUserCharactersGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      tap((result) => {
        this.patchEntities(ctx, result.data.getUserCharacters as Character[]);
      })
    );
  }

  @Action(CharactersSaveAction)
  saveCharacter(ctx: StateContext<any>, action: CharactersSaveAction) {
    const saveData = action.payload.character;
    const isUpdate = !!saveData._id;

    const dto = {
      bodyTypeKey: saveData.bodyTypeKey || '',
      characterPaperDollImageUrl: saveData.characterPaperDollImageUrl || null,
      characterProfileImageUrl: saveData.characterProfileImageUrl || null,
      hairColorKey: saveData.hairColorKey || '',
      skinToneKey: saveData.skinToneKey || '',
    };

    if (isUpdate) {
      return this.updateCharacterGQL.mutate({ dto: { _id: saveData._id, ...dto } }, { context: { ignoreLoading: true } }).pipe(
        tap((result: MutationResult) => {
          this.patchEntity(ctx, result?.data?.updateCharacter as Character);
        })
      );
    } else {
      return this.createCharacterGQL.mutate({ dto }, { context: { ignoreLoading: true } }).pipe(
        tap((result: MutationResult) => {
          this.patchEntity(ctx, result?.data?.createCharacter as Character);
        })
      );
    }
  }
}
